import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { connect } from 'react-redux';
import { Link, Redirect, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as auth from '../_redux/authRedux';
import { Auth } from 'aws-amplify';
import { TextField } from '../../../components/TextFieldInput';
import { parse } from 'querystring';

const initialValues = {
  email: '',
  code: '',
  password: '',
};

function ForgotPassword(props) {
  const { intl, history } = props;
  const [isRequested, setIsRequested] = useState(false);
  const [hasSubmited, setHasSubmited] = useState(false);
  const [hasQuery, setHasQuery] = useState(false);
  const { search } = useLocation();
  const queryString = parse(search.replace('?', ''));

  useEffect(() => {
    if (Object.keys(queryString).length) {
      formik.setFieldValue('email', queryString.email);
      formik.setFieldValue('code', queryString.code);
      setHasQuery(true);
    }
    // eslint-disable-next-line
  }, []);

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(
        intl.formatMessage({
          id: 'GENERAL.WRONG_EMAIL',
        })
      )
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        })
      ),
    code: Yup.string(),
    password: Yup.string(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      try {
        await Auth.forgotPassword(values.email);
        setHasSubmited(true);
      } catch (e) {
        console.error(e);
      } finally {
        setIsRequested(false);
        setSubmitting(false);
      }
    },
  });

  async function changePassword(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    try {
      await Auth.forgotPasswordSubmit(
        formik.values.email,
        formik.values.code,
        formik.values.password
      );
      history.push('/auth/login');
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div
          className="login-form login-forgot"
          style={{ display: 'block', maxWidth: 520 }}
        >
          {hasQuery ? (
            <>
              <form
                onSubmit={changePassword}
                className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
              >
                <TextField
                  labelMinSize={100}
                  field="password"
                  inputSize="100%"
                  formik={formik}
                  label={intl.formatMessage({ id: 'AUTH.INPUT.NEW_PASSWORD' })}
                  type="password"
                />
                <div className="d-flex justify-content-end">
                  <div>
                    <button
                      id="kt_login_forgot_submit"
                      type="submit"
                      className="btn btn-primary font-weight-bold"
                      onClick={changePassword}
                      disabled={
                        !formik.values.email ||
                        !formik.values.code ||
                        !formik.values.password
                      }
                    >
                      {intl.formatMessage({ id: 'AUTH.FORGOT.CONFIRM' })}
                    </button>
                  </div>
                </div>
              </form>
            </>
          ) : hasSubmited ? (
            <>
              <div className="text-center mb-10 mb-lg-20">
                <h4>
                  {intl.formatMessage({ id: 'AUTH.FORGOT.PASSWORD.RESETED' })}
                </h4>
              </div>
            </>
          ) : (
            <>
              <div className="text-center mb-10 mb-lg-20">
                <h4>{intl.formatMessage({ id: 'AUTH.FORGOT.TITLE' })}</h4>
              </div>
              <form
                onSubmit={formik.handleSubmit}
                className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
              >
                {formik.status && (
                  <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                    <div className="alert-text font-weight-bold">
                      {formik.status}
                    </div>
                  </div>
                )}
                <TextField
                  field="email"
                  inputSize="100%"
                  formik={formik}
                  label={intl.formatMessage({ id: 'AUTH.INPUT.EMAIL' })}
                />
                <div
                  className="form-group d-flex flex-wrap align-items-center"
                  style={{ justifyContent: 'space-between' }}
                >
                  <div style={{ minWidth: 80 }}></div>
                  <Link
                    to="/auth/login"
                    className="text-dark-50 text-hover-primary my-3 mr-20"
                    id="kt_login_forgot"
                  >
                    <FormattedMessage id="AUTH.LOGIN.BUTTON" />
                  </Link>
                  <button
                    id="kt_login_forgot_submit"
                    type="submit"
                    className="btn btn-primary font-weight-bold px-7"
                    disabled={formik.isSubmitting || hasSubmited}
                  >
                    {intl.formatMessage({ id: 'AUTH.FORGOT.PASSWORD.RESET' })}
                    {formik.isSubmitting && (
                      <span className="ml-2 spinner spinner-white"></span>
                    )}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
